import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';

import {LocaleLink} from '@/routes';
import logo from '@/assets/images/logo.png';
import {blank} from '@/util';
import {userCtx} from '@/auth';
import {SystemConfigCtx} from '@/contexts';
import MainSiteLink from '@/components/MainSiteLink';
import * as supportLink from '@/contexts/support-link';

import Member from '@/views/Layout/b2c/Member';
import LangMenu from '@/views/Layout/b2c/LangMenu';

import styles from '@/views/Layout/b2c/Header.module.css';

const Header = () => {
  const user = useContext(userCtx);
  const {t: tr} = useTranslation();
  const {siteCode} = useContext(SystemConfigCtx);

  const handlePrint = event => {
    event.preventDefault();
    window.print();
  };

  if (blank(siteCode)) {
    return null;
  }

  return (
    <header>
      <div className='container clearfix'>
        <LocaleLink to='/' className='logo' id='logo'>
          <img
            alt='Athena Best'
            src={logo}
            className={`logo_img ${styles.logo_img}`}
          />
        </LocaleLink>
        <nav className='wide'>
          {user.currentClient && (
            <div id='logout'>
              <LocaleLink to='/logout'>{tr('logout')}</LocaleLink>
            </div>
          )}
          <ul className='clearfix'>
            {/*
            <li className='inline'>
              <a href='/' className='font-size s'>
                A
              </a>
              <a href='/' className='font-size m'>
                A
              </a>
              <a href='/' className='font-size l'>
                A
              </a>
            </li>
            */}
            <LangMenu />
            <li>
              <MainSiteLink href={supportLink.contactUs(siteCode)}>
                {tr('contact_us')}
              </MainSiteLink>
            </li>
            <li>
              <a href='/' onClick={handlePrint}>
                <i className='printer-icon' />
              </a>
            </li>
          </ul>
          <Member />
        </nav>

        <nav className='narrow menu'>
          <a
            href='/'
            onClick={e => {
              e.preventDefault();
            }}
          >
            <i className='material-icons'>menu</i>
          </a>
          <ul>
            {user.currentClient && (
              <li>
                <LocaleLink to='/logout'>{tr('logout')}</LocaleLink>
              </li>
            )}
            <li>
              <LocaleLink to='/b2c'>{tr('my_plan')}</LocaleLink>
            </li>
            <li>
              <LocaleLink to='/b2c/my_profile'>{tr('my_profile')}</LocaleLink>
            </li>
            <li>
              <LocaleLink to='/b2c/message'>
                <i className='notification'>
                  {user.currentClient.messageCount}
                </i>{' '}
                {tr('message_box')}
              </LocaleLink>
            </li>
            <li>
              <LocaleLink to='/b2c/change_password'>
                {tr('change_password_button')}
              </LocaleLink>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
